import { useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import Link from 'next/link'
import { Navigation, Autoplay, Pagination } from 'swiper'
import { useDispatch, useSelector } from 'react-redux'
import { getOffersList } from '../../redux/slices/common'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/autoplay'
import { Skeleton, Box, Typography, Grid, Stack } from '@mui/material'

const BannerSlider = ({ router, pageName }) => {
  const capitalizedPageName = pageName
    ? pageName.charAt(0).toUpperCase() + pageName.slice(1)
    : ''
  const dispatch = useDispatch()
  const [banners, setBanners] = useState([])
  const { bannerList } = useSelector(state => state.common)
  const [isBannerDisabled, setIsBannerDisabled] = useState(false)
  const [loader, setLoader] = useState(true)

  useEffect(() => {
    const isFlightOrHotels = pageName === 'flights' || pageName === 'hotels'
    if (!isFlightOrHotels) {
      setLoader(true)
      dispatch(getOffersList())
    }
    setBanners([])
    setIsBannerDisabled(isFlightOrHotels)
  }, [router.asPath])

  useEffect(() => {
    if (bannerList && bannerList !== undefined) {
      const filteredBanners = bannerList?.filter(
        item => item.name === capitalizedPageName
      )
      if (filteredBanners.length > 0) {
        setLoader(false)
        setBanners(filteredBanners[0].backgroundImages)
      }
    }
  }, [bannerList])

  if (banners?.length === 0  || isBannerDisabled) {
    return null
  }

  return loader ? (
    <div className='mb-2 mb-md-5 mt-0'>
      <Skeleton variant='rectangular' width='100%' height={180} />
    </div>
  ) : (
    <div className='banner-slider-container mb-2 mb-md-5 mt-0'>
      <Swiper
        modules={[Autoplay, Pagination]}
        autoplay={{ delay: 3000 }}
        speed={2000}
        pagination={{ clickable: true }}
        className='banner-slider'
        style={{ width: '100%', height: '100%' }}
        spaceBetween={20}
      >
        {banners?.map((item, index) => (
          <SwiperSlide key={index}>
            <Link href={item?.link} key={item._id} target='_blank'>
              <img
                src={`${process.env.IMAGE_BASE_URL}/${item.image}`}
                alt={`Banner ${index + 1}`}
                className='banner-image'
              />
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}

export default BannerSlider
